import react, {useEffect,useState} from 'react';
import { Spin, Tree, Image as AntdImage, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import Api from "../../../../api";
import Iconfont from "../../../../components/Iconfont/Iconfont";
import departmentIcon from "../../../../assets/img/V7/departmentIcon.svg";

import './index.scss';

const DepartmentTree = ({
    knowledgeTypeId,
    deparmentChange
}) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    const [departmentSpinning, setDepartmentSpinning] = useState(true);
    const [departmentList, setDepartmentList] = useState([]);
    const [departmentItem, setDepartmentItem] = useState({});

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);

    useEffect(()=>{
        if(knowledgeTypeId){
            clearSelect();
            getDepartmentList();
        }
    },[knowledgeTypeId])

    const getDepartmentList = async() => { 
        setDepartmentSpinning(true);
        try{
            const res = await Api.Department.getDepartmentListAll({data:{
                knowledgeRel: 0,
                knowledgeTypeIds: [knowledgeTypeId]
            }});
            setDepartmentSpinning(false);
            setDepartmentItem({id:'9999'});
            if(res&&res.code === 0&&res.data){
                setDepartmentList(res.data);
            }else{
                setDepartmentList([]);
            }
        }catch(e){
            setDepartmentItem({id:'9999'});
            setDepartmentSpinning(false);
            setDepartmentList([]);
        }
        
    }

    const selectAll = (item) => {
        console.log('Department', item)
        setDepartmentItem(item);
        if(item.id === '9999'){
            // 点击全部
            clearSelect();
            deparmentChange([]);
        }
    }

    const changeDepartment = (item) =>{ 
        // 是否展开
        if(item.id != '9999'){
            let _departmentList = [...departmentList]
            _departmentList.map(items => { 
                if(items.id === item.id){
                    items.open = !items.open;
                    if(!item.children){
                        items.loading = true;
                    }
                }
            })
            setDepartmentList(_departmentList);

            if(!item.children){
                // 获取子分类
                getDepartmentTree(item.id)
            }
        }
    }

    const getDepartmentTree = async (departmentId) => { 
        const res = await Api.Department.getDepartmentTree({data:{
            departmentId: departmentId,
            knowledgeTypeId: knowledgeTypeId,
        }});

        if(res.code === 0){
            let _departmentList = [...departmentList]
            _departmentList.map(item => { 
                if(item.id === departmentId){
                    item.open = true;
                    item.loading = false;
                    item.children = res.data || [];
                }
            })
            setDepartmentList(_departmentList)
        }
    }

    
    const onExpand = (expandedKeysValue) => {
        console.log('onExpand', expandedKeysValue);
        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };
    const onCheck = (checkedKeysValue, info) => {
        console.log('onCheck', checkedKeysValue, info);
        let _checkedKeys = {...checkedKeys};
        _checkedKeys[info.node.departmentId] = checkedKeysValue;
        console.log('_checkedKeys', _checkedKeys);


        let deptVos = [];
        for(let key in _checkedKeys){
            if(_checkedKeys[key] && _checkedKeys[key].length > 0){
                deptVos.push({
                    "departmentId": key,
                    "departmentSubclassificationIds": _checkedKeys[key]
                })
            }
        }

        console.log(deptVos,"deptVos")
        if(deptVos.length === 0){
            selectAll({id:'9999'})
        }else{
            deparmentChange(deptVos);
            setCheckedKeys(_checkedKeys);
            setDepartmentItem({
                id:info.node.departmentId
            });
        }
        
    };
    const onSelect = (selectedKeysValue, info) => {
        
        let _selectedKeysValue = [info.node.id]
        let _checkedKeys = {...checkedKeys};
        let newCheckedKeys = []


        if(_checkedKeys[info.node.departmentId] && _checkedKeys[info.node.departmentId].includes(info.node.id)){
            newCheckedKeys = _checkedKeys[info.node.departmentId].filter(item=>!_selectedKeysValue.includes(item))
        }else{
             newCheckedKeys = _checkedKeys[info.node.departmentId] ? [..._checkedKeys[info.node.departmentId],..._selectedKeysValue] : [..._selectedKeysValue];
        }

        
        // if(info.selected){
        //     newCheckedKeys = _checkedKeys[info.node.departmentId] ? [..._checkedKeys[info.node.departmentId],..._selectedKeysValue] : [..._selectedKeysValue];
        // }else{
        //     newCheckedKeys = _checkedKeys[info.node.departmentId].filter(item=>!_selectedKeysValue.includes(item))
        // }
        

        onCheck(newCheckedKeys, info)
        console.log('onSelect', _selectedKeysValue,info);
        // setSelectedKeys(_selectedKeysValue);
    };

    const clearSelect = () => {
        setCheckedKeys([]);
        setExpandedKeys([]);
        // setSelectedKeys([]);
    }

    return (
        <div className="classificationTree">
            <Spin indicator={antIcon} spinning={departmentSpinning}>
                <div className={`allClassification ${departmentItem.id === '9999' ? 'active':''}`}  onClick={()=>selectAll({id:'9999'})}><Iconfont type={'icon-fenlei'}/>全部</div>
                {departmentList && departmentList.length > 0 && departmentList.map(item=>{
                    return <div key={item.id}>
                        {/* `classification ${departmentItem.id === item.id ? 'active':''}` */}
                        <div className={`classification`} onClick={()=>changeDepartment(item)}>
                            <AntdImage
                                preview={false}
                                src={departmentIcon}
                            />
                            <Tooltip title={item.name}>
                                <div className="classificationName">{item.name}</div>
                            </Tooltip>
                            
                            <Iconfont type={`${item.open ? 'icon-xiala':'icon-shangjiantou4'}`}/> 
                            
                        </div>
                    
                        {item.open&&<Spin indicator={antIcon} spinning={item.loading}><div className="treeBox">
                            {item.children&&item.children.length===0&&<div className="noData">暂无数据</div>}
                            <Tree
                                checkable
                                onExpand={onExpand}
                                expandedKeys={expandedKeys}
                                autoExpandParent={autoExpandParent}
                                onCheck={onCheck}
                                checkedKeys={checkedKeys[item.id]}
                                selectable={false}
                                // onSelect={onSelect}
                                // selectedKeys={selectedKeys}
                                treeData={item.children}
                                fieldNames={{ title: 'subclassification', key: 'id', children: 'childList' }}
                            />
                        </div></Spin>}
                    </div>
                })}
            </Spin>
        </div>
    )
}

export default DepartmentTree;